import type { MapMetadata } from '@/types/api';
import { MapCard } from './MapCard';

interface MapGridProps {
  maps: MapMetadata[];
  isLoading?: boolean;
}

export function MapGrid({ maps, isLoading }: MapGridProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="animate-pulse">
            <div className="h-48 bg-shadow-600 rounded-t-lg"></div>
            <div className="bg-shadow-700 p-4 rounded-b-lg border border-t-0 border-stone-800">
              <div className="h-4 bg-shadow-600 rounded w-3/4 mb-2"></div>
              <div className="h-3 bg-shadow-600 rounded w-full mb-1"></div>
              <div className="h-3 bg-shadow-600 rounded w-2/3"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (maps.length === 0) {
    return (
      <div className="text-center py-12">
        <svg
          className="mx-auto h-12 w-12 text-stone-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        <h3 className="mt-2 text-lg font-medium text-stone-100">No maps found</h3>
        <p className="mt-1 text-base text-stone-400">Try a different search query.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {maps.map((map) => (
        <MapCard key={map.id} map={map} />
      ))}
    </div>
  );
}
